import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { Option, OptionKey } from '@common-fe/common-fe';

import { api } from '@/api';
import { Pagination } from '@/common/types';
import { API_URL } from '@/dtos';

import { FieldLevelAccessValue, IFieldLLevelAccess } from '../../role.types';

interface Response {
  id: number;
  name: string;
  description: string;
  roles_applied_to: string;
  properties: {
    [key: string]: FieldLevelAccessValue;
  };
  overridable_properties: {
    [key: string]: FieldLevelAccessValue;
  };
}

// mock.onGet(API_URL.ORGANIZATION_PROPERTIES_STATE_CONFIGS).reply(200, {
//   content: [
//     {
//       id: 0,
//       name: 'string',
//       description: 'string',
//       roles_applied_to: ['string'],
//       properties: {
//         additionalProp1: 'EDIT',
//         additionalProp2: 'EDIT',
//         additionalProp3: 'EDIT',
//       },
//       overridable_properties: {
//         additionalProp1: 'EDIT',
//         additionalProp2: 'EDIT',
//         additionalProp3: 'EDIT',
//       },
//     },
//     {
//       id: 1,
//       name: 'String 2',
//       description: 'string 2',
//       roles_applied_to: ['string'],
//       properties: {
//         additionalProp1: 'EDIT',
//         additionalProp2: 'EDIT',
//         additionalProp3: 'EDIT',
//       },
//       overridable_properties: {
//         additionalProp1: 'EDIT',
//         additionalProp2: 'EDIT',
//         additionalProp3: 'EDIT',
//       },
//     },
//   ],
//   number: 0,
//   sort: [
//     {
//       direction: 'string',
//       nullHandling: 'string',
//       ascending: true,
//       property: 'string',
//       ignoreCase: true,
//     },
//   ],
//   empty: true,
// });

interface Params {
  id?: OptionKey;
}
const useFieldLevelAccessListQuery = ({ id }: Params) => {
  const { data, isLoading, refetch } = useQuery([API_URL.ORGANIZATION_PROPERTIES_STATE_CONFIGS], () =>
    // TODO: type is missing
    api.get<Pagination<Response>>(API_URL.ORGANIZATION_PROPERTIES_STATE_CONFIGS, {
      params: {
        page: 0,
        size: 1000,
      },
    })
  );

  const options: Option[] = useMemo(() => {
    const list = data?.data?.content;

    const formattedList: Option[] =
      list?.map((item) => ({
        key: `${item.id}`,
        title: item.name,
        value: item.name,
      })) || [];
    return formattedList;
  }, [data?.data?.content]);
  const currentFieldLevelAccess = useMemo(() => {
    if (!id) {
      return null;
    }
    const list = data?.data?.content || [];
    const foundItem = list.find((item) => `${item.id}` === id);
    if (foundItem) {
      const formattedItem: IFieldLLevelAccess = {
        id: `${foundItem.id}`,
        name: foundItem.name,
        description: foundItem.description,
        properties: foundItem.properties,
        overridableProperties: foundItem.overridable_properties,
      };
      return formattedItem;
    }
    return null;
  }, [data?.data?.content, id]);
  return {
    currentFieldLevelAccess,
    options,
    isLoading,
    refetch,
  };
};
export default useFieldLevelAccessListQuery;
